import React, { useEffect, useState } from "react";
import "../styles/Tickets.css";

function Tickets() {
  const [campaignData, setCampaignData] = useState([]);
  const [allCampaignData, setAllCampaignData] = useState([
    {
      request_number: 265478,
      status: 0,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 1,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 1,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 0,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 1,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 0,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 1,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 0,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
    {
      request_number: 265478,
      status: 1,
      service_type: "Request For Server Access",
      service_category: "Server",
      description: "Test123",
      loaction: "Bhopal",
      assigned_to: "Alka",
      created_on: "19/06/2023",
    },
  ]);

  useEffect(() => {
    setCampaignData(allCampaignData);
  }, [allCampaignData]);

  function addTicket(e) {}

  return (
    <div className="it-ticket">
      <div className="ticket-container">
        <div className="create-ticket">
          <div className="raise-ticket">
            <button data-bs-toggle="modal" data-bs-target="#addTicketModal">
              <i className="fa-solid fa-plus"></i>Raise IT Desk Ticket
            </button>
            <p>
              <i className="fa-solid fa-border-all"></i>
              <span>My Requests</span>
            </p>
          </div>
          <div className="search-ticket">
            <div className="search">
              <input type="text" placeholder="Search" id="search" />
              <i className="fa-solid fa-magnifying-glass"></i>
            </div>
            <div className="download">
              <i className="fa-solid fa-filter"></i>
              <i className="fa-solid fa-download"></i>
            </div>
          </div>
        </div>
        <div className="ticket-listing">
          <table>
            <thead>
              <tr>
                <th className="actions-th">Actions</th>
                <th>Request Number</th>
                <th>Status</th>
                <th>Service Type</th>
                <th>Service Category</th>
                <th>Description</th>
                <th>Location</th>
                <th>Assigned To</th>
                <th>Created On</th>
              </tr>
            </thead>
            <tbody>
              {campaignData?.length > 0 &&
                campaignData?.map((d, i) => {
                  return (
                    <tr key={"item-" + i}>
                      <td className="actions-td">
                        <span>{i + 1}</span>
                        <i className="fa-solid fa-bars"></i>
                        <i className="fa-solid fa-ban"></i>
                      </td>
                      <td>{d?.request_number}</td>
                      <td className={d?.status === 0 ? "inactive" : "active"}>
                        <span>{d?.status === 0 ? "Closed" : "New Ticket"}</span>
                      </td>
                      <td>{d?.service_type}</td>
                      <td>{d?.service_category}</td>
                      <td>{d?.description}</td>
                      <td>{d?.loaction}</td>
                      <td>{d?.assigned_to}</td>
                      <td>{d?.created_on}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div className="ticket-footer">
          <span>Total Record Count: {campaignData?.length}</span>
        </div>
      </div>

      <div
        className="modal fade"
        id="addTicketModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel">
                Raise IT Desk Ticket
              </h6>
              <button
                id="close"
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form>
                <div className="row m-0">
                  <div className="col-md-6 my-3">
                    <label for="service-type" className="col-form-label">
                      Service Type<sup>*</sup>
                    </label>
                    <select className="form-select" id="service-type">
                      <option value="IT Service">IT Service</option>
                      <option value="Hardware Service">Hardware Service</option>
                      <option value="Software Service">Software Service</option>
                      <option value="Request Service">Request Service</option>
                      <option value="Change Service">Change Service</option>
                    </select>
                  </div>
                  <div className="col-md-6 my-3">
                    <label for="location" className="col-form-label">
                      Location<sup>*</sup>
                    </label>
                    <select className="form-select" id="location">
                      <option value="Bhopal">Bhopal</option>
                      <option value="Bangalore">Bangalore</option>
                      <option value="Indore">Indore</option>
                      <option value="Pune">Pune</option>
                      <option value="Delhi">Delhi</option>
                    </select>
                  </div>
                  <div className="col-md-6 my-3">
                    <label for="priority" className="col-form-label">
                      Priority<sup>*</sup>
                    </label>
                    <select className="form-select" id="priority">
                      <option value="Sev1">Sev1</option>
                      <option value="Sev2">Sev2</option>
                      <option value="Sev3">Sev3</option>
                      <option value="Sev4">Sev4</option>
                      <option value="Sev5">Sev5</option>
                    </select>
                  </div>

                  <div className="col-md-6 my-3">
                    <label for="inputFile" className="col-form-label">
                      Upload File(s)
                    </label>
                    <input
                      type="file"
                      className="form-control file"
                      id="inputFile"
                    />
                  </div>

                  <div className="col mb-5 mt-3 txt">
                    <label for="message-text" className="col-form-label">
                      Description<sup>*</sup>
                    </label>
                    <textarea
                      className="form-control"
                      id="message-text"
                    ></textarea>
                  </div>
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger close"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn add">
                Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tickets;
